export enum ModuleKey {
  PCM = 'pcm',
  BPA = 'bpa',
  CLOUDAGENTS = 'cloudagents',
  ENDPOINTS = 'endpoints',
  WEBAPPS = 'webapps',
  SAST = 'sast',
  KPI = 'kpi',
}

export type ModuleKeyType = `${ModuleKey}`;

export interface Module {
  id: string;
  name: string;
  key: ModuleKeyType;
  description?: string;
  is_enabled: boolean;
}

export interface ModulesResponse {
  enabled_modules: ModuleKeyType[];
  modules: Module[];
}

export interface CompanyData {
  custom_logo_css: string;
  display_name: string;
  enabled_modules: ModuleKeyType[];
  id: number;
  label: string;
  logo: string;
  name: string;
  value: number;
}
